import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { DadosFilialOrcamento, DadosTrocarFilialOrcamento } from "app/types/TrocarFilialOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react"
import { TrocarFilialOrcamento } from "./TrocarFilialOrcamento";
import { IFilial } from "app/types/IFilial";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { Parametro } from "app/types/Parametro";

export type TrocarFilialOrcamentoContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>;
}

export const TrocarFilialOrcamentoContainer = (props: TrocarFilialOrcamentoContainerProps) => {

    const [dadosTrocarFilial, setDadosTrocarFilial] = useState<Partial<DadosTrocarFilialOrcamento>>(null)
    const [filiais, setFiliais] = useState<IFilial[]>([])
    const [processando, setProcessando] = useState<boolean>(false);
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [permissaoValida, setPermissaoValida] = useState<boolean>(true)
    const isMounted = useRef(true);
    
    const atualizarParametros = async () => {
        setParametros(
            await obterParametrosPorOidItem({
                nomes: [
                    "SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO",
                ],
                oidItem: props.orcamentoSelecionado.OidFilial ?? 1
            })
        );
    };

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const onObterDadosTrocaFilialOrcamento = async () => {
        try {
            
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.ObterDadosTrocarFilialOrcamento(props.orcamentoSelecionado.NumeroPedido);
            
            if (!isMounted.current) return;
            
            if (!resultado || "HasErrors" in resultado) {
                onVoltar();
                return;
            }
            
            setDadosTrocarFilial(resultado);
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            if (isMounted.current) globalMU.unblockUI();
        }
    }

    const onListarFiliais = async (nome?: string) => {
        try {
            
            globalMU.blockUI();
            const resposta = await microuniversoApi.Orcamento.ObterListaFiliaisOrcamento(props.orcamentoSelecionado.Filial, nome);
            if (isMounted.current && !("HasErrors" in resposta)) {
                setFiliais(resposta)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            if (isMounted.current) globalMU.unblockUI();
        }
    }

    const onExcluirControleDeExclusividade = async () => {
        try {
            
            globalMU.blockUI()
            await microuniversoApi.Comum.excluirControleDeExclusividade(props.orcamentoSelecionado.NumeroPedido.toString(), "PEDICLICAD");
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onValidarPermissaoSenhaVenda = async (senha: string) => {
        try {
            
            globalMU.blockUI();
            const resposta = await microuniversoApi.Comum.ValidarPermissaoSenhaVenda(senha, ["TIPO_LIBERACAO_LIBERA_TROCA_FILIAL_ORCAMENTO"]);
            if (isMounted.current && resposta === "OK") {
                setPermissaoValida(true)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            if (isMounted.current) globalMU.unblockUI();
        }
    }

    const onSalvarTrocaFilial = async (dados: Partial<DadosFilialOrcamento>) => {
        try {
            setProcessando(true);
            globalMU.blockUI();
            const resposta = await microuniversoApi.Orcamento.TrocarFilial(dados.Numero, dados.CodigoNovaFilial,
                dados.OidFilialPedido, dados.SenhaAutorizarTrocaFilial);

            if (!resposta) {
                globalMU.showErrorMessage("Não foi possível trocar a filial!");
                return
            }

            globalMU.showSuccessMessage("Troca de Filial concluída com sucesso!");
            onVoltar();

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            if (isMounted.current) setProcessando(false);
            if (isMounted.current) globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        
        props.onRemover()
        passosInterno.current.get(passo)()
        dadosTrocarFilial != null && passo == "Pesquisa de Orçamento" && onExcluirControleDeExclusividade();
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
        dadosTrocarFilial != null && onExcluirControleDeExclusividade();
    }

    useEffect(() => {
     
        isMounted.current = true;
        const carregarDados = async () => {
            passosInterno.current.set("Trocar Filial do Orçamento", () => { })
            await Promise.all([
                atualizarParametros(),
                onObterDadosTrocaFilialOrcamento(),
                onListarFiliais()
            ]);
        }
        carregarDados();
        return () => { isMounted.current = false; }
    }, []);

    useEffect(() => {
        
        $.connection.hub.disconnected(function () {
            //onVoltar()
        });
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="TrocarFilialContainer"
                processando={processando}
                onPassoSelecionado={!processando ? onPassoSelecionado : () => {}}
                onBotaoVoltarClicado={!processando ? onVoltar : () => {}}
            />

            <TrocarFilialOrcamento
                dadosTrocarFilialOrcamento={dadosTrocarFilial}
                processando={processando}
                filiais={filiais}
                pedirSenha={valorParametro("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO") === "S" && permissaoValida}
                ontrocarFilial={onSalvarTrocaFilial}
                onPesquisarFiliais={onListarFiliais}
                onErrorValidacao={(erroFormulario) => globalMU.showErrorMessage(erroFormulario)}
                onValidarPermissao={onValidarPermissaoSenhaVenda}
            />
        </>
    )

}